import { createApp } from 'vue'

import EPSInfoApp from '@/pages/earnings_calls/EPSInfoApp.vue'

const newsApp = createApp(EPSInfoApp)

newsApp.mount('#earnings-calls-eps-info-app')
